export default "__VITE_ASSET__ky6YfqqN__"